export * from './floating-menu.component';
export * from './floating-menu.module';
